import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { State } from 'vuex-class';
import moment from 'moment';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppCheckbox from '@/components/AppCheckbox.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppTextField from '@/components/AppTextField.vue';
import AppSelector from '@/components/AppSelector.vue';
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppSimpleSelector from '@/components/AppSimpleSelector.vue';
import AppSimpleTextField from '@/components/AppSimpleTextField.vue';
import AppSimpleDatePicker from '@/components/AppSimpleDatePicker.vue';
import AppSimpleSearchSelector from '@/components/AppSimpleSearchSelector.vue';
import AppRadio from '@/components/AppRadio.vue';
import AppLightModal from '@/components/AppLightModal.vue';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';
import { utcDateTimeToLocal, formatWeixinDate } from '@/utils/dateTime';
import ListPage from '@/mixins/list-page';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import { findOrders, findAllPeriod, exportOrdersList, exportOrdersStatList } from './gql';
import { OrdersOrderBy, OrderStatus } from '@/interfaces/order';
import { statusCodes, statusOptions, OrderStatusText, refundOptions, refundKey, RefundWayText } from '@/helpers/order';
import { createRefund, cancelRefund } from '../RefundList/gql';
import AppTextarea from '@/components/AppTextarea.vue';
import AuthFilter from '@/mixins/auth-filter';
import { findDealers } from '@/views/DealerList/gql';
import { auditStatusText } from '@/helpers/audit';
import { formatCurrency } from '@/utils/currency';
import { findSchools } from '../SchoolList/gql';
import { downloadBase64 } from '@/helpers/base64-to-file';
import { dispatchUpdateIfNewOrders } from '../../store/dispatches';

var OrderList = /*#__PURE__*/function (_mixins) {
  _inherits(OrderList, _mixins);

  var _super = _createSuper(OrderList);

  function OrderList() {
    var _this;

    _classCallCheck(this, OrderList);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '订单管理'
    }, {
      text: '订单'
    }];
    _this.options = {
      sortBy: ['createdAt'],
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    };
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.formatWeixinDate = formatWeixinDate;
    _this.formatCurrency = formatCurrency;
    _this.OrderStatusText = OrderStatusText;
    _this.filter = {
      area: null,
      orderNumber: null,
      transactionNumber: null,
      period_EQ: -1,
      dealerId: {
        id: null,
        label: ''
      },
      orderTimeStart: null,
      orderTimeEnd: null,
      phone: null,
      realname: null,
      studentName: null,
      schoolName: null,
      statusIndex: -1,
      schoolIndex: -1,
      createdAt_GTE_DATE: moment().subtract(1, 'M').format('YYYY-MM-DD'),
      createdAt_LTE_DATE: moment().format('YYYY-MM-DD')
    };
    _this.totalNum = 0;
    _this.totalAmount = '';
    _this.loading = false;
    _this.headers = [{
      text: '操作',
      value: 'operation',
      sortable: false,
      width: 100
    }, {
      text: '退款方式',
      value: 'refund.refundWay',
      sortable: false,
      width: 140
    }, {
      text: '审核状态',
      value: 'refund.auditStatus',
      sortable: false,
      width: 120
    }, {
      text: '订单状态',
      value: 'status',
      width: 150
    }, {
      text: '征订周期',
      value: 'period',
      sortable: false,
      width: 130
    }, {
      text: '经销商',
      value: 'dealer.realname',
      sortable: false,
      width: 120
    }, {
      text: '订单编号',
      value: 'orderNumber',
      width: 200
    }, {
      text: '订单流水编号',
      value: 'transactionNumber',
      width: 200
    }, {
      text: '商品/单价',
      value: 'items'
    }, {
      text: '买家',
      value: 'address',
      width: 140
    }, {
      text: '支付',
      value: 'payWay',
      sortable: false,
      width: 90
    }, {
      text: '价格',
      value: 'totalPrice',
      width: 80
    }, {
      text: '下单时间',
      value: 'createdAt',
      width: 120
    }, {
      text: '付款时间',
      value: 'timeEnd',
      width: 120
    }, {
      text: '备注',
      value: 'buyerMessage',
      sortable: false,
      width: 80
    }];
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.statusCodes = statusCodes();
    _this.statusOptions = statusOptions();
    _this.refundDialog = {
      show: false,
      title: '创建退款单',
      disable: false,
      confirmText: '创建退款单'
    };
    _this.refundInput = {};
    _this.refundTypeDialog = {
      show: false,
      title: '选择退款方式'
    };
    _this.refundOptions = refundOptions();
    _this.refundKey = refundKey();
    _this.RefundWayText = RefundWayText;
    _this.AuditStatusText = auditStatusText;
    _this.refundWithdrawDialog = {
      show: false,
      text: '确认撤销退款?'
    };
    _this.periodOptions = [];
    _this.dealerOptions = [];
    _this.OrderStatus = OrderStatus;
    _this.actionsHeight = 51;
    _this.orders = [];
    _this.orderInfo = null;
    _this.schools = [];
    _this.schoolOptions = [];
    _this.confirmForm = false;
    _this.delayClock = null;
    return _this;
  }

  _createClass(OrderList, [{
    key: "usingStatus",
    value: function usingStatus(status) {
      return {
        'u-tag-blue': status === this.OrderStatus.TO_BE_PAID,
        'u-tag-red': status === this.OrderStatus.ERROR,
        'u-tag-orange': status === this.OrderStatus.REFUNDING,
        'u-tag-green': status === this.OrderStatus.SUCCESS,
        'u-tag-dark': status === this.OrderStatus.CLOSED,
        'u-tag-grey': status === this.OrderStatus.REFUND,
        'u-tag-yellow': status === this.OrderStatus.PAID
      };
    }
  }, {
    key: "onOptionsChanged",
    value: function onOptionsChanged() {
      this.getOrders();
    }
  }, {
    key: "onAreaChanged",
    value: function onAreaChanged(val) {
      var _this2 = this;

      if (this.delayClock) {
        clearTimeout(this.delayClock);
        this.delayClock = null;
      }

      if (!val) {
        this.schoolOptions = [];
        return;
      }

      this.delayClock = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this2$querySc;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.querySchoolsRequest(val.id);

              case 2:
                _context.t1 = _yield$_this2$querySc = _context.sent;
                _context.t0 = _context.t1 !== null;

                if (!_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = _yield$_this2$querySc !== void 0;

              case 6:
                if (!_context.t0) {
                  _context.next = 10;
                  break;
                }

                _context.t2 = _yield$_this2$querySc;
                _context.next = 11;
                break;

              case 10:
                _context.t2 = [];

              case 11:
                _this2.schoolOptions = _context.t2;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), 2000);
    }
  }, {
    key: "onDateRangeChanged",
    value: function onDateRangeChanged(startDate) {
      var endDate = this.filter.createdAt_LTE_DATE;
      var startMmt = moment(startDate);
      var endMmt = moment(endDate);

      if (!startDate) {
        return;
      }

      if (startMmt.isAfter(endMmt)) {
        this.filter.createdAt_LTE_DATE = null;
      }
    }
  }, {
    key: "onDateRangeChanged2",
    value: function onDateRangeChanged2(endDate) {
      var startDate = this.filter.createdAt_GTE_DATE;
      var startMmt = moment(startDate);
      var endMmt = moment(endDate);

      if (!endDate) {
        return;
      }

      if (startMmt.isAfter(endMmt)) {
        this.filter.createdAt_GTE_DATE = null;
        return;
      }

      if (startMmt.isBefore(endMmt.subtract(1, 'M'))) {
        this.filter.createdAt_GTE_DATE = endMmt.subtract(1, 'M').format('YYYY-MM-DD');
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.getRole() === 'dealer') {
        this.headers.shift();
      }

      this.onResize();
      this.restorePage(this.cache);
      this.getOrders();
      this.getPeriodOptions();
      this.getDealerOptions();
    }
  }, {
    key: "getOrders",
    value: function () {
      var _getOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$options, sortBy, page, itemsPerPage, sortDesc, _this$filter, orderNumber, statusIndex, period_EQ, transactionNumber, phone, dealerId, schoolIndex, createdAt_GTE_DATE, createdAt_LTE_DATE, area, realname, by, asc, order, paging, where, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$options = this.options, sortBy = _this$options.sortBy, page = _this$options.page, itemsPerPage = _this$options.itemsPerPage, sortDesc = _this$options.sortDesc;
                _this$filter = this.filter, orderNumber = _this$filter.orderNumber, statusIndex = _this$filter.statusIndex, period_EQ = _this$filter.period_EQ, transactionNumber = _this$filter.transactionNumber, phone = _this$filter.phone, dealerId = _this$filter.dealerId, schoolIndex = _this$filter.schoolIndex, createdAt_GTE_DATE = _this$filter.createdAt_GTE_DATE, createdAt_LTE_DATE = _this$filter.createdAt_LTE_DATE, area = _this$filter.area, realname = _this$filter.realname;
                by = OrdersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                paging = {
                  skip: itemsPerPage * (page - 1),
                  take: itemsPerPage * page
                };
                where = {
                  orderNumber: orderNumber || null,
                  status_EQ: this.statusCodes[statusIndex] || null,
                  period_EQ: this.periodOptions[period_EQ] || null,
                  transactionNumber: transactionNumber,
                  phone: phone,
                  realname: realname || null,
                  dealerId: dealerId ? dealerId.id : null,
                  schoolId: schoolIndex >= 0 ? this.schools[schoolIndex].id : null,
                  createdAt_GTE_DATE: createdAt_GTE_DATE || null,
                  createdAt_LTE_DATE: createdAt_LTE_DATE || null,
                  mailingAddress: area ? area.mergerName : null
                };
                _context2.next = 10;
                return this.queryOrdersRequest(order, paging, where);

              case 10:
                result = _context2.sent;

                if (result) {
                  this.orders = result.orders;
                  this.totalNum = result.paging.totalCount;
                  this.totalAmount = result.totalAmount;
                }

                this.loading = false;
                this.storePage();
                dispatchUpdateIfNewOrders({
                  order: false
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getOrders() {
        return _getOrders.apply(this, arguments);
      }

      return getOrders;
    }()
  }, {
    key: "getPeriodOptions",
    value: function () {
      var _getPeriodOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findAllPeriod
                });

              case 3:
                result = _context3.sent;

                if (result) {
                  this.periodOptions = result.data.findAllUsedPeriodSettings;
                }

                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getPeriodOptions() {
        return _getPeriodOptions.apply(this, arguments);
      }

      return getPeriodOptions;
    }()
  }, {
    key: "getDealerOptions",
    value: function () {
      var _getDealerOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(query) {
        var where, take, result, typedError;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                where = query && query.model ? {
                  realname: query.model
                } : null;
                take = query && query.take ? query.take : 20;
                _context4.prev = 2;
                _context4.next = 5;
                return this.$apollo.query({
                  query: findDealers,
                  variables: {
                    order: null,
                    paging: {
                      skip: 0,
                      take: take
                    },
                    where: where
                  }
                });

              case 5:
                result = _context4.sent;

                if (result.data.findDealers) {
                  this.dealerOptions = result.data.findDealers.dealers.map(function (option) {
                    return {
                      id: option.id,
                      label: option.realname
                    };
                  });
                }

                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 9]]);
      }));

      function getDealerOptions(_x) {
        return _getDealerOptions.apply(this, arguments);
      }

      return getDealerOptions;
    }()
  }, {
    key: "querySchoolsRequest",
    value: function () {
      var _querySchoolsRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(areaId) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.$apollo.query({
                  query: findSchools,
                  variables: {
                    where: {
                      areaId: areaId
                    }
                  }
                });

              case 3:
                result = _context5.sent;
                this.schools = result.data.findSchools.schools;
                return _context5.abrupt("return", this.schools.map(function (school) {
                  return school.name;
                }));

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                typedError = _context5.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));

      function querySchoolsRequest(_x2) {
        return _querySchoolsRequest.apply(this, arguments);
      }

      return querySchoolsRequest;
    }()
  }, {
    key: "queryOrdersRequest",
    value: function () {
      var _queryOrdersRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(order, paging, where) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.$apollo.query({
                  query: findOrders,
                  variables: {
                    order: order,
                    paging: paging,
                    where: where
                  }
                });

              case 3:
                result = _context6.sent;
                return _context6.abrupt("return", result.data.findOrders);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                typedError = _context6.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function queryOrdersRequest(_x3, _x4, _x5) {
        return _queryOrdersRequest.apply(this, arguments);
      }

      return queryOrdersRequest;
    }()
  }, {
    key: "routeToDetail",
    value: function routeToDetail(item) {
      this.$router.push({
        name: 'OrderDetail',
        params: {
          id: item.id + '',
          orderNumber: item.orderNumber
        }
      });
    }
  }, {
    key: "filterQuerySubmit",
    value: function filterQuerySubmit() {
      this.getOrders();
    }
  }, {
    key: "refreshList",
    value: function refreshList() {
      this.filter = {
        area: null,
        orderNumber: null,
        transactionNumber: null,
        orderTimeStart: null,
        orderTimeEnd: null,
        phone: null,
        realname: null,
        studentName: null,
        schoolName: null,
        statusIndex: -1,
        period_EQ: -1,
        dealerId: {
          id: null,
          label: ''
        },
        schoolIndex: -1,
        createdAt_GTE_DATE: null,
        createdAt_LTE_DATE: null
      };
      this.getOrders();
    }
  }, {
    key: "exportSchoolOrders",
    value: function () {
      var _exportSchoolOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this$options2, sortBy, sortDesc, _this$filter2, orderNumber, statusIndex, period_EQ, transactionNumber, phone, dealerId, schoolIndex, createdAt_GTE_DATE, createdAt_LTE_DATE, area, realname, by, asc, order, where, result, _result$data$exportOr, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options2 = this.options, sortBy = _this$options2.sortBy, sortDesc = _this$options2.sortDesc;
                _this$filter2 = this.filter, orderNumber = _this$filter2.orderNumber, statusIndex = _this$filter2.statusIndex, period_EQ = _this$filter2.period_EQ, transactionNumber = _this$filter2.transactionNumber, phone = _this$filter2.phone, dealerId = _this$filter2.dealerId, schoolIndex = _this$filter2.schoolIndex, createdAt_GTE_DATE = _this$filter2.createdAt_GTE_DATE, createdAt_LTE_DATE = _this$filter2.createdAt_LTE_DATE, area = _this$filter2.area, realname = _this$filter2.realname;
                by = OrdersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  orderNumber: orderNumber || null,
                  status_EQ: this.statusCodes[statusIndex] || null,
                  period_EQ: this.periodOptions[period_EQ] || null,
                  transactionNumber: transactionNumber,
                  phone: phone,
                  realname: realname || null,
                  dealerId: dealerId ? dealerId.id : null,
                  schoolId: this.schools[schoolIndex] ? this.schools[schoolIndex].id : null,
                  createdAt_GTE_DATE: createdAt_GTE_DATE || null,
                  createdAt_LTE_DATE: createdAt_LTE_DATE || null,
                  mailingAddress: area ? area.mergerName : null
                };
                _context7.prev = 8;
                _context7.next = 11;
                return this.$apollo.query({
                  query: exportOrdersList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 11:
                result = _context7.sent;

                if (result.data) {
                  _result$data$exportOr = result.data.exportOrdersList, fileName = _result$data$exportOr.fileName, contentB64 = _result$data$exportOr.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context7.next = 20;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7["catch"](8);
                typedError = _context7.t0;
                showErrors(typedError.graphQLErrors);

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[8, 16]]);
      }));

      function exportSchoolOrders() {
        return _exportSchoolOrders.apply(this, arguments);
      }

      return exportSchoolOrders;
    }()
  }, {
    key: "exportSchoolOrdersStat",
    value: function () {
      var _exportSchoolOrdersStat = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this$options3, sortBy, sortDesc, _this$filter3, orderNumber, statusIndex, period_EQ, transactionNumber, phone, dealerId, schoolIndex, createdAt_GTE_DATE, createdAt_LTE_DATE, by, asc, order, where, result, _result$data$exportOr2, fileName, contentB64, typedError;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.filter.schoolIndex === -1)) {
                  _context8.next = 3;
                  break;
                }

                showNotification({
                  msg: '请先选择学校',
                  type: SnackType.Error
                });
                return _context8.abrupt("return");

              case 3:
                showNotification({
                  msg: '即将开始下载...',
                  type: SnackType.Info
                });
                _this$options3 = this.options, sortBy = _this$options3.sortBy, sortDesc = _this$options3.sortDesc;
                _this$filter3 = this.filter, orderNumber = _this$filter3.orderNumber, statusIndex = _this$filter3.statusIndex, period_EQ = _this$filter3.period_EQ, transactionNumber = _this$filter3.transactionNumber, phone = _this$filter3.phone, dealerId = _this$filter3.dealerId, schoolIndex = _this$filter3.schoolIndex, createdAt_GTE_DATE = _this$filter3.createdAt_GTE_DATE, createdAt_LTE_DATE = _this$filter3.createdAt_LTE_DATE;
                by = OrdersOrderBy[sortBy[0] || 'createdAt'];
                asc = !sortDesc[0] || false;
                this.loading = true;
                order = {
                  by: by,
                  asc: asc
                };
                where = {
                  orderNumber: orderNumber || null,
                  status_EQ: this.statusCodes[statusIndex] || null,
                  period_EQ: this.periodOptions[period_EQ] || null,
                  transactionNumber: transactionNumber,
                  phone: phone,
                  dealerId: dealerId ? dealerId.id : null,
                  schoolId: this.schools[schoolIndex].id,
                  createdAt_GTE_DATE: createdAt_GTE_DATE || null,
                  createdAt_LTE_DATE: createdAt_LTE_DATE || null
                };
                _context8.prev = 11;
                _context8.next = 14;
                return this.$apollo.query({
                  query: exportOrdersStatList,
                  variables: {
                    order: order,
                    where: where
                  }
                });

              case 14:
                result = _context8.sent;

                if (result.data) {
                  _result$data$exportOr2 = result.data.exportOrdersStatList, fileName = _result$data$exportOr2.fileName, contentB64 = _result$data$exportOr2.contentB64;
                  downloadBase64(contentB64, fileName);
                }

                this.loading = false;
                _context8.next = 23;
                break;

              case 19:
                _context8.prev = 19;
                _context8.t0 = _context8["catch"](11);
                typedError = _context8.t0;
                showErrors(typedError.graphQLErrors);

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[11, 19]]);
      }));

      function exportSchoolOrdersStat() {
        return _exportSchoolOrdersStat.apply(this, arguments);
      }

      return exportSchoolOrdersStat;
    }()
  }, {
    key: "refundHandler",
    value: function refundHandler(item) {
      this.orderInfo = JSON.parse(JSON.stringify(item));
      this.orderInfo.totalPrice = Number(this.formatCurrency(this.orderInfo.totalPrice));
      this.refundInput = {};
      this.refundTypeDialog.show = true;
    }
  }, {
    key: "refundTypeConfirm",
    value: function refundTypeConfirm() {
      if (typeof this.refundInput.refundType !== 'undefined') {
        this.refundDialog.show = true;
        this.refundTypeDialog.show = false;
      } else {
        showNotification({
          msg: '请选择退款类型!',
          type: SnackType.Info
        });
      }
    }
  }, {
    key: "refundTypeCancel",
    value: function refundTypeCancel() {
      this.refundTypeDialog.show = false;
    }
  }, {
    key: "refundWithdrawHandler",
    value: function refundWithdrawHandler(item) {
      this.orderInfo = item;
      this.refundWithdrawDialog.show = true;
    }
  }, {
    key: "refundWithdrawCancel",
    value: function refundWithdrawCancel() {
      this.refundWithdrawDialog.show = false;
    }
  }, {
    key: "refundWithdrawConfirm",
    value: function () {
      var _refundWithdrawConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _this$orderInfo, result, typedError;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.$apollo.mutate({
                  mutation: cancelRefund,
                  variables: {
                    orderId: (_this$orderInfo = this.orderInfo) === null || _this$orderInfo === void 0 ? void 0 : _this$orderInfo.id
                  }
                });

              case 3:
                result = _context9.sent;

                if (result) {
                  this.refundWithdrawDialog.show = false;
                  showNotification({
                    msg: '撤销退款成功',
                    type: SnackType.Success
                  });
                  this.getOrders();
                }

                _context9.next = 13;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);
                this.confirmForm = false;
                this.refundDialog.show = false;
                typedError = _context9.t0;
                showErrors(typedError.graphQLErrors);

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));

      function refundWithdrawConfirm() {
        return _refundWithdrawConfirm.apply(this, arguments);
      }

      return refundWithdrawConfirm;
    }()
  }, {
    key: "refundFormConfirm",
    value: function () {
      var _refundFormConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _this$refundInput, description, refundType, _this$orderInfo2, result, typedError;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.confirmForm = true;
                _this$refundInput = this.refundInput, description = _this$refundInput.description, refundType = _this$refundInput.refundType;
                _context10.prev = 2;
                _context10.next = 5;
                return this.$apollo.mutate({
                  mutation: createRefund,
                  variables: {
                    orderId: (_this$orderInfo2 = this.orderInfo) === null || _this$orderInfo2 === void 0 ? void 0 : _this$orderInfo2.id,
                    description: description,
                    refundWay: this.refundKey[refundType]
                  }
                });

              case 5:
                result = _context10.sent;

                if (result) {
                  this.confirmForm = false;
                  this.refundDialog.show = false;
                  showNotification({
                    msg: '创建退款单成功',
                    type: SnackType.Success
                  });
                  this.refundInput = {};
                  this.getOrders();
                }

                _context10.next = 15;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](2);
                this.confirmForm = false;
                this.refundDialog.show = false;
                typedError = _context10.t0;
                showErrors(typedError.graphQLErrors);

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[2, 9]]);
      }));

      function refundFormConfirm() {
        return _refundFormConfirm.apply(this, arguments);
      }

      return refundFormConfirm;
    }()
  }, {
    key: "refundFormCancel",
    value: function refundFormCancel() {
      this.refundInput = {};
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }, {
    key: "rightDateLimit",
    get: function get() {
      return {
        max: moment().format('YYYY-MM-DD'),
        min: this.filter.createdAt_GTE_DATE ? moment(this.filter.createdAt_GTE_DATE).format('YYYY-MM-DD') : null
      };
    }
  }]);

  return OrderList;
}(mixins(ListPage, AuthFilter));

__decorate([State(function (state) {
  return state.page.OrderList;
})], OrderList.prototype, "cache", void 0);

__decorate([Watch('options', {
  deep: true
})], OrderList.prototype, "onOptionsChanged", null);

__decorate([Watch('filter.area', {
  deep: true
})], OrderList.prototype, "onAreaChanged", null);

__decorate([Watch('filter.createdAt_GTE_DATE', {
  deep: true
})], OrderList.prototype, "onDateRangeChanged", null);

__decorate([Watch('filter.createdAt_LTE_DATE', {
  deep: true
})], OrderList.prototype, "onDateRangeChanged2", null);

OrderList = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppCheckbox: AppCheckbox,
    AppRefreshAndExport: AppRefreshAndExport,
    AppDialog: AppDialog,
    AppSimpleTextField: AppSimpleTextField,
    AppSimpleSelector: AppSimpleSelector,
    AppDatePicker: AppDatePicker,
    AppSearchBtn: AppSearchBtn,
    AppSelector: AppSelector,
    AppTextField: AppTextField,
    AppSimpleDatePicker: AppSimpleDatePicker,
    AppLightModal: AppLightModal,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppTextarea: AppTextarea,
    AppRadio: AppRadio,
    AppSimpleSearchSelector: AppSimpleSearchSelector
  }
})], OrderList);
export default OrderList;